import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import Handling_item_table from "./handling_item_table/Handling_item_table";
import Handling_item_Form from "./handling_item_Form/Handling_item_Form";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/calibration_item/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Handling_item() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const calibration_item = useSelector((state) => state.calibration_item); 
 
 

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: calibration_item.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const permissions = useSelector((state) => state.auth.permissions);
                                      
  const haveReadPermission = permissions?.includes(FixIDS.calibration_item.List);
  const haveAddPermission = permissions?.includes(FixIDS.calibration_item.Add); //form

  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Handling Of Test Or Calibration Item" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
             Handling of test or calibration items is carried out with proper identification, protection, and traceability from receipt to disposal. Each item is checked, labeled, & stored under controlled conditions to prevent damage, contamination, or deterioration. Any abnormalities are documented & communicated immediately. These practices ensure reliable results in accordance with ISO/IEC 17025:2017.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          { haveAddPermission && <Handling_item_Form fetchCustomers={fetchCustomers}/>}
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Handling_item_table 
            data={calibration_item}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}/> }
        </div>

       
      </section>
    </>
  );
}

export default Handling_item;
